import {ReactElement} from 'react';
import {useSession} from "next-auth/react";
import {Button} from "@/components/ui/button";
import Link from "next/link";

const AccountBannerComponent = (): ReactElement  => {

  const { data, status } = useSession()

  return (
    <div className='bg-primary bg-rrb-banner py-12 px-16 text-white rounded'>
      <div className='flex flex-wrap justify-between items-center'>
        <span className='text-[32px]'>Bonjour {data?.user?.name && data.user.name}</span>

        <Button variant={"secondary"} asChild>
          <Link href={"/mon-compte/preferences"}>
            Gérer mon espace
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default AccountBannerComponent;